// Model.js
// -----------------------
// @module Case
define("Convergence.TopDealsExty.TopDealsExt.Collection", 
    [
        "Item.Collection"
    ,   "Utils"
    ,   "Profile.Model"
    ,   "Convergence.TopDealsExt.TopDealsExt.Model"
    ,   "Session"
    ,   "SC.Configuration"
    ,   "underscore"
    ,   'Item.Model'
    ], 
    function(
        ItemCollection
    ,   Utils
    ,   ProfileModel
    ,   TopDealsExtModel
    ,   Session
    ,   Configuration
    ,   _
    ,   ItemModel
  
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return ItemCollection.extend({
        customfacetsID: 'custitem_convergence_offer_zone_items',
        pageSize:20,
        url: function () {
            
            
            var profile = ProfileModel.getInstance(),
                sessionSearchApiParams = Session.getSearchApiParams(false);

            

            delete sessionSearchApiParams[this.customfacetsID];
            sessionSearchApiParams.fieldset = "search";
            sessionSearchApiParams.custitem_convergence_offer_zone_items = 'TopDeals'
            var url = _.addParamsToUrl(
                profile.getSearchApiUrl(),
                _.extend(
                    (Configuration.get('matrixchilditems.enabled') && Configuration.get('matrixchilditems.fieldset')) ? {
                        matrixchilditems_fieldset: Configuration.get('matrixchilditems.fieldset')
                    } : {},
                    this.searchApiMasterOptions,
                    sessionSearchApiParams
                ),
                profile.isAvoidingDoubleRedirect()
            );

            return url;
        },
        model: ItemModel,
        // model: TopDealsExtModel,
                
        parse: function (response) {
            this.totalRecordsFound = response.total;
            
            
            // this.recordsPerPage = this.pageSize;
            // this.recordsPerPage = this.currentPerPage === undefined? this.pageSize: this.currentPerPage;
            
            return response.items;
        },
        update: function (options, list_header) {
            var self = this,
            sortOrder

            
            
            // switch (options && options.sort && options.sort.value) {
            //     case 'price':
            //     sortOrder = 'onlinecustomerprice';
            //     break;
            //     case 'name':
            //     sortOrder = 'storedisplayname';
            //     break;
            //     default:
            //     sortOrder = 'custitem_bb1_sca_webcategory';
            //     break;
            // }
            // this.currentPerPage = options.PerpageSize ? options.PerpageSize : this.pageSize;
      
            
            var dataFilters = {
                fieldset: 'search',
                sort: (options.order > 0 ? ':asc' : ':asc'),
                // sort: sortOrder + (options.order > 0 ? ':asc' : ':desc'),
                limit: options.PerpageSize ? options.PerpageSize : this.pageSize,
                offset: this.pageSize * (parseInt(options.page || 1, 10) - 1)
            };
            
                dataFilters[this.customersFacetId] = profile.get('customerFacetValueUrl') || 'XXXXXXXXXXXXXXXX';
            
            this.fetch({
                data: dataFilters,
                reset: true,
                killerId: options.killerId
            });
        }
        
    });
});
